import PageHero from "@/components/common/PageHero";
import FinalCTA from "@/components/sections/FinalCTA";
import { ArrowUpRight, Calendar } from "lucide-react";
import Reveal from "@/components/common/Reveal";

const posts = [
  {
    title: "The 7-step CRO framework we use to double Shopify conversion rates",
    excerpt: "Our internal CRO playbook — the same one we run for 8-figure brands. From research to test design to scaling winners.",
    img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
    date: "Feb 12, 2026", tag: "CRO",
  },
  {
    title: "Meta Ads in 2026: what's actually working for D2C right now",
    excerpt: "Creative formats, audience strategy, and budget allocation that's beating the iOS-era benchmarks.",
    img: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=900&q=80",
    date: "Feb 04, 2026", tag: "Paid Media",
  },
  {
    title: "Shopify speed: a sub-2s LCP playbook (without breaking your store)",
    excerpt: "The exact technical checklist we run on every Shopify Plus build to hit Core Web Vitals green.",
    img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
    date: "Jan 28, 2026", tag: "Performance",
  },
  {
    title: "Why your AOV is stuck — and how to add $40 in 14 days",
    excerpt: "Five upsell, cross-sell, and bundling tactics our team layers in for instant AOV lifts.",
    img: "https://images.unsplash.com/photo-1556745753-b2904692b3cd?auto=format&fit=crop&w=900&q=80",
    date: "Jan 20, 2026", tag: "Funnels",
  },
  {
    title: "From $100K to $1M/month: the operating cadence that scales D2C",
    excerpt: "How weekly KPI reviews, creative sprints, and CRO experiments compound into 10x growth.",
    img: "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=900&q=80",
    date: "Jan 12, 2026", tag: "Growth",
  },
  {
    title: "Product page anatomy: 12 sections that convert in 2026",
    excerpt: "We dissect the highest-converting Shopify PDPs we've shipped this year.",
    img: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=900&q=80",
    date: "Jan 04, 2026", tag: "Design",
  },
];

export default function BlogPage() {
  return (
    <main data-testid="blog-page">
      <PageHero
        eyebrow="Insights"
        title={<>Field notes from the<br /><span className="text-gradient">growth frontline.</span></>}
        subtitle="Tactical playbooks, frameworks, and case breakdowns. No fluff."
      />
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {posts.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.04}>
              <article data-testid={`blog-post-${i}`} className="group h-full overflow-hidden rounded-3xl bg-[#0A0A0C] border border-white/5 hover:border-blue-500/30 transition flex flex-col">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={p.img} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <span className="absolute top-4 left-4 text-xs glass-heavy px-3 py-1 rounded-full text-zinc-200">{p.tag}</span>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 text-xs text-zinc-500"><Calendar className="h-3 w-3" /> {p.date}</div>
                  <h3 className="mt-3 font-display text-xl font-bold text-white leading-snug">{p.title}</h3>
                  <p className="mt-3 text-sm text-zinc-400 leading-relaxed flex-1">{p.excerpt}</p>
                  <div className="mt-5 inline-flex items-center gap-1.5 text-sm text-blue-300 font-semibold">
                    Read article <ArrowUpRight className="h-4 w-4" />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCTA />
    </main>
  );
}
